import type { SVGProps } from "react";

export function PlayerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 256 256"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill="currentColor"
        d="M197.6,97.3c4,0,7.3,3.3,7.3,7.4c0,4.1-3.3,7.4-7.3,7.4l0,0V97.3z"
      />
      <path
        fill="currentColor"
        d="M96.9,102.9v41.4c0,0,0,10.4,10.1,10.4s40.7-20.7,40.7-31.1c0-10.4-30.5-31.1-40.7-31.1S96.9,102.9,96.9,102.9z"
      />
      <path
        fill="currentColor"
        d="M185.5,97.3c0,17,13.6,30.8,30.2,30.8c16.7,0,30.3-13.8,30.3-30.8s-13.6-30.8-30.2-30.8c-2.1,0-4.1,0.2-6.1,0.6c-25.9-40-73.2-58.5-118.9-46.1c-58,15.8-92.6,76.7-77,135.6c13,49.4,57.1,82.1,105.2,82.1c9.3,0,18.8-1.2,28.2-3.8c31-8.5,56.6-30.3,70.3-59.9c1.4-3.1,0.1-6.7-2.9-8.2c-3-1.4-6.6-0.1-8,2.9c-12.2,26.3-34.9,45.7-62.5,53.2c-51.5,14-104.8-17.2-118.6-69.6C11.6,101.1,42.3,47,93.9,32.9c39.9-10.9,81.2,5,104.5,39.3C190.6,77.8,185.5,86.9,185.5,97.3z M215.8,78.8c10,0,18.2,8.3,18.2,18.4c0,10.2-8.1,18.5-18.2,18.5c-10,0-18.2-8.3-18.2-18.4C197.6,87.1,205.7,78.8,215.8,78.8z"
      />
    </svg>
  );
}
